module.exports = __webpack_public_path__ + "img/chrome-icon.753ff6c3.svg";